import { EventEmitter, Injectable } from '@angular/core';

import { Placeholder, PlaceholderType
       } from 'collage-designer/stage/placeholder/placeholder';

@Injectable()
export class ToolboxService
{
  private static readonly TOOLBOXES: Record<string, string> = {
      'ProductChooserToolbox': 'top-bar',
      'LayoutToolbox': 'design-step',
      'GalleryToolbox': 'design-step',
      'TextEditToolbox': 'design-step',
      'TextToolbox': 'placeholder',
      'ImageEditToolbox': 'placeholder',
      'ImageToolbox': 'design-step',
  };
  public targetChanged: EventEmitter<undefined> = new EventEmitter();
  public closeRequested: EventEmitter<string> = new EventEmitter();
  public createNewPlaceholderInitialized: EventEmitter<PlaceholderType> =
      new EventEmitter();
  public duplicatePlaceholderInitialized: EventEmitter<Placeholder> =
      new EventEmitter();

  private activeToolboxNames: Array<string> = [];

  public toggle(toolboxName: string): void
  {
    if (this.activeToolboxNames.includes(toolboxName)) {
      this.cleanUp(toolboxName);
    }
    else {
      this.open(toolboxName);
    }
  }

  public open(toolboxName: string): void
  {
    const previousOpened = this.getActiveToolboxName(
        ToolboxService.TOOLBOXES[toolboxName]);
    if (previousOpened && previousOpened !== toolboxName) {
      this.cleanUp(previousOpened);
    }
    if (!this.activeToolboxNames.includes(toolboxName)) {
      this.activeToolboxNames.push(toolboxName);
    }
    this.targetChanged.emit();
  }

  public getActiveToolboxName(group: string): string|undefined
  {
    const toolboxNames = this.activeToolboxNames.filter(
        n => ToolboxService.TOOLBOXES[n] === group);
    if (!toolboxNames) {
      return undefined;
    }
    else {
      return toolboxNames[0];
    }
  }

  public getActiveToolboxCount(): number
  {
    return this.activeToolboxNames.length;
  }

  public closeLastOpenedToolbox(): void
  {
    const toolboxName =
        this.activeToolboxNames[this.activeToolboxNames.length - 1];
    if (toolboxName === undefined) {
      return;
    }

    this.closeRequested.emit(toolboxName);
  }

  public closeActiveToolbox(): void
  {
    for (const toolboxName of this.activeToolboxNames) {
      this.cleanUp(toolboxName);
    }
  }

  public cleanUp(toolboxName: string): void
  {
    this.activeToolboxNames =
        this.activeToolboxNames.filter(e => e !== toolboxName);
    this.targetChanged.emit();
  }

  public createNewPlaceholder(type: PlaceholderType): void
  {
    this.createNewPlaceholderInitialized.emit(type);
  }

  public duplicatePlaceholder(placeholder: Placeholder): void
  {
    this.duplicatePlaceholderInitialized.emit(placeholder);
  }
}
